var render = function render(_c,_vm){return _c('div',{staticClass:"b2b-card__text",class:{
  [_vm.data.staticClass]: !!_vm.data.staticClass,
  'b2b-card__text--fill-height': _vm.props.fillHeight,
  'b2b-card__text--row': _vm.props.row,
  'b2b-card__text--scrollable': _vm.props.scrollable,
}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.data.domProps && _vm.data.domProps.textContent))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }